import { render, staticRenderFns } from "./grabbedLayerView.vue?vue&type=template&id=838d7bac&"
import script from "./grabbedLayerView.vue?vue&type=script&lang=ts&"
export * from "./grabbedLayerView.vue?vue&type=script&lang=ts&"
import style0 from "./grabbedLayerView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports